import { render } from "./SubpageTitleContainer.vue?vue&type=template&id=9768478e&scoped=true"
import script from "./SubpageTitleContainer.vue?vue&type=script&lang=js"
export * from "./SubpageTitleContainer.vue?vue&type=script&lang=js"

import "./SubpageTitleContainer.vue?vue&type=style&index=0&id=9768478e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9768478e"]])

export default __exports__